import { useAppSelector } from '@redux/hooks';
import { SkeletonLoading } from '@sharedUi/SkeletonLoading';
import { TypeAlertInfo, AlertInfo } from '@app/shared';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import { TitleList } from '@app/shared/ui/WrapperList/TitleList';
import LogoIcon from './img/logo-icon.svg';
import Cover from './img/cover.svg';
import CardMobile from './img/card-mobile.svg';

import styles from './DiscountListCards.module.scss';

export const DiscountListCards = ({ data, title }) => {
  const isMobile = useWindowSizing(420);
  const userPhone = useAppSelector(state => state.auth?.userPhone);

  const { cardNum, serv, goods } = data;

  return (
    <div className={styles.WrapperMeinCard}>
      <TitleList title={title} />
      <AlertInfo type={TypeAlertInfo.Success} className={styles.Notificate}>
        Карта привязана к телефону! Чтобы воспользоваться скидками, просто скажите номер {userPhone} на кассе.
      </AlertInfo>
      <div className={styles.Wrapper}>
        <div className={styles.Container}>
          <div className={styles.BlockCard}>
            <p>Моя карта Колесо.ру</p>
            <p className={styles.Nums}>{cardNum}</p>
            <p>{userPhone}</p>
            <div className={styles.Percent}>
              <div className={styles.Info}>
                <p>
                  {serv}% на {isMobile && 'все'} услуги
                </p>
                <p>
                  {goods}% на {isMobile && 'все'} товары
                  <p className={styles.Small}>кроме шин и дисков</p>
                </p>
              </div>
              <div className={styles.Logo}>{!isMobile ? <LogoIcon width={180} height={190} /> : <CardMobile width={182} height={280} />}</div>
            </div>
          </div>
        </div>
        {!isMobile && (
          <div>
            <Cover width={420} height={280} />
          </div>
        )}
      </div>
      <span>Как воспользоваться?</span>
      <p className={styles.Desc}>Чтобы воспользоваться скидками, просто назовите Ваш номер телефона на кассе шинного центра.</p>
      <p className={styles.Desc}>Пока нельзя применить скидку по дисконтной карте при покупке на сайте.</p>
    </div>
  );
};

DiscountListCards.Skeleton = function Skeleton() {
  return (
    <>
      <SkeletonLoading width={'100%'} height={'167px'} />
      <SkeletonLoading width={'100%'} height={'167px'} />
      <SkeletonLoading width={'100%'} height={'167px'} />
    </>
  );
};
